// Hindsight unavailable notice — shown when the HINDSIGHT_ENABLED feature flag is disabled
// (globally or for this account). Replaces the Hindsight page so a user who reaches the route
// directly gets a clear "not available" instead of a page whose data calls 404. Mirrors
// AidnUnavailableNotice.

import PropTypes from 'prop-types';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { IconLock } from '@tabler/icons-react';

export default function HindsightUnavailableNotice({ reason }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          p: 4,
          borderRadius: 3,
          border: 1,
          borderColor: 'divider',
          textAlign: 'center'
        }}
      >
        <Stack spacing={2} alignItems="center">
          <IconLock size={48} stroke={1.5} />
          <Typography variant="h4" component="h1">
            Hindsight is currently unavailable
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {reason || 'Hindsight is currently unavailable. Please try again later.'}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

HindsightUnavailableNotice.propTypes = {
  reason: PropTypes.string
};
